@if (isShipmentCancelled()) {
  <div class="order-cancelled">Order cancelled</div>
} @else if(isAllShipmentLinesCancelled()) {
   <div class="order-cancelled">Order cancelled. All lines have been cancelled.</div>
} @else {
  <div class="order-progress-steps-container flex-layout no-wrap start-content" style="gap: 0;" >
    @for (progressStep of orderShipment().lineGroups; track progressStep.status; let isFirst = $first; let isLast = $last) {
      <div class="progress-step-container item-grow">
        <span class="flex-layout progress-step-bar-container start-content" style="gap: 0;">
          <span class="progress-bar before item-grow"
            [class.show]="!isFirst"
          [class.completed-status]="progressStep.status <= orderShipment().status"></span>
          <span class="progress-bar indicator item-grow"
            [class.active-status]="progressStep.status === orderShipment().status"
            [class.completed-status]="progressStep.status <= orderShipment().status">
          </span>
          <span class="progress-bar after item-grow"
            [class.show]="!isLast"
          [class.completed-status]="progressStep.status < orderShipment().status"></span>
        </span>
        <div class="progress-label" [class.active]="progressStep.status === orderShipment().status">
          {{orderUtilityService.mapOrderDetailsStatus(progressStep.status, orderShipment().orderType)}}
        </div>
      </div>
    }
  </div>
}
